import React, { useState, useEffect } from 'react';

const KapcsolatOldal = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pageStyle = {
    padding: isMobile ? '1.5rem' : '2rem',
    fontFamily: 'Arial, sans-serif',
    maxWidth: isMobile ? '100%' : '800px',
    margin: isMobile ? '0 auto' : '2rem auto',
    backgroundColor: '#f9f9f9',
    borderRadius: isMobile ? '0' : '8px',
    boxShadow: isMobile ? 'none' : '0 2px 4px rgba(0,0,0,0.1)',
    color: '#333',
    minHeight: isMobile ? 'calc(100vh - 55px)' : 'auto'
  };

  const headingStyle = {
    color: '#b30000',
    borderBottom: '2px solid #b30000',
    paddingBottom: '0.5rem',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontSize: isMobile ? '1.5rem' : '2rem'
  };

  const contactItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.5rem',
    fontSize: isMobile ? '1rem' : '1.1rem',
    lineHeight: '1.6'
  };

  const linkStyle = {
    color: '#b30000',
    textDecoration: 'none',
    fontWeight: 'bold',
    marginLeft: '0.5rem',
    wordBreak: 'break-all'
  };

  const iconStyle = {
    marginRight: '12px',
    fontSize: '1.6rem',
    color: '#b30000',
    minWidth: '30px',
    textAlign: 'center'
  };

  return (
    <div className="force-light-theme" style={pageStyle}>
      <h1 style={headingStyle}>Kapcsolatfelvétel</h1>
      <p style={{ marginBottom: '2.5rem', fontSize: isMobile ? '0.95rem' : '1.1rem', lineHeight: '1.6', textAlign: 'center' }}>
        Ha kérdésed van, vagy szeretnél kapcsolatba lépni velünk, az alábbi elérhetőségeken teheted meg:
      </p>

      <div style={contactItemStyle}>
        <span style={iconStyle} role="img" aria-label="Email ikon">📧</span>
        <div>
          <strong>Email:</strong>
          <a href="mailto:robert.marki@live.com" style={linkStyle}>robert.marki@live.com</a>
        </div>
      </div>

      <div style={contactItemStyle}>
        <span style={iconStyle} role="img" aria-label="Facebook ikon">📘</span>
        <div>
          <strong>Facebook:</strong>
          <a href="https://www.facebook.com/profile.php?id=61580003427158" target="_blank" rel="noopener noreferrer" style={linkStyle}>
            Archery Nexus a Facebookon
          </a>
        </div>
      </div>

      <p style={{ marginTop: '3rem', fontSize: '1rem', fontStyle: 'italic', textAlign: 'center', color: '#555' }}>
        Minden megkeresésre igyekszünk a lehető leghamarabb válaszolni. Köszönjük türelmed!
      </p>
    </div>
  );
};

export default KapcsolatOldal;
